import React, { useContext } from 'react';
import { SafeAreaView, ScrollView, View, Text } from 'react-native';
import { ApolloProvider } from '@apollo/client';
import styled from 'styled-components/native';
import DataTable from '@preflighttech/preflight-tables';

import Footer from 'app/src/components/Footer';
import Home from 'app/src/components/Home';
import Menu from 'app/src/components/Menu';
import ClientContext from 'app/src/contexts/ClientContext';
import PageContent from 'app/src/elements/PageContent';
import Routes from 'app/src/routes';
import colors from 'app/src/styles/colors';
import { Router } from 'app/src/utils/routing';

const Screen = styled(SafeAreaView)`
  min-height: 100%;
  background-color: ${colors.background};
`;

const ContentWrapper = styled(ScrollView)`
  flex: 1;
`;

const Content = styled(View)`
  padding: 32px 48px;
  max-width: 1200px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
`;

// For mobile, reduce padding
const MobileContent = styled(View)`
  padding: 20px;
`;

const Main = () => {
  const { apolloClient, isMobile } = useContext(ClientContext);

  const ContentContainer = isMobile ? MobileContent : Content;

  return (
    <Router>
      <ApolloProvider client={apolloClient}>
        <Screen>
          <Menu />

          <ContentWrapper>
            <ContentContainer>
              <DataTable.Provider
                pageLength={25}
                lengthMenu={ [10, 25, 50, 'All'] }
                htmlTable
              >
                <PageContent>
                  <Routes />
                </PageContent>
              </DataTable.Provider>
            </ContentContainer>
          </ContentWrapper>

          <Footer />
        </Screen>
      </ApolloProvider>
    </Router>
  );
};

export default Main;
